import { CartLinesUpdateEvent, StandardEvents } from '@shopify/events';

/* Arkipelag: lägg till merköp (örngott, lakan) i varukorgen och håll bottenmenyns räknare uppdaterad. */

function sectionIds() {
  const ids = [];
  document.querySelectorAll('cart-items-component').forEach((el) => {
    if (el instanceof HTMLElement && el.dataset.sectionId) ids.push(el.dataset.sectionId);
  });
  return ids.join(',');
}

function cartJsonUrl() {
  return (window.Theme && Theme.routes && Theme.routes.cart_url ? Theme.routes.cart_url : '/cart') + '.js';
}

function setCount(count) {
  const el = document.querySelector('[data-ark-cart-count]');
  if (!el || typeof count !== 'number') return;
  el.textContent = String(count);
  el.hidden = count === 0;
}

async function addVariant(variantId, button) {
  const deferred = CartLinesUpdateEvent.createPromise();
  button.dispatchEvent(
    new CartLinesUpdateEvent({
      action: 'add',
      context: 'product',
      lines: [{ merchandiseId: String(variantId), quantity: 1 }],
      promise: deferred.promise,
    })
  );
  try {
    const addUrl = window.Theme && Theme.routes && Theme.routes.cart_add_url ? Theme.routes.cart_add_url : '/cart/add';
    const response = await fetch(addUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1 }], sections: sectionIds() }),
    });
    const result = await response.json();
    const cart = await fetch(cartJsonUrl(), { headers: { Accept: 'application/json' } }).then((r) => r.json());
    deferred.resolve({
      cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cart),
      detail: {
        items: cart.items,
        source: 'ark-cart',
        sourceId: 'ark-cart',
        itemCount: 1,
        sections: result.sections,
        didError: Boolean(result.status),
      },
    });
    return !result.status;
  } catch (error) {
    deferred.reject(error);
    return false;
  }
}

document.addEventListener('click', async (event) => {
  const target = event.target instanceof Element ? event.target : null;
  const button = target && target.closest('[data-ark-add], [data-ark-cx-add]');
  if (!(button instanceof HTMLButtonElement) || button.disabled) return;
  const variantId = button.dataset.variant || button.getAttribute('data-ark-cx-add');
  if (!variantId) return;
  const label = button.textContent;
  button.disabled = true;
  const ok = await addVariant(variantId, button);
  if (button.isConnected) {
    button.textContent = ok ? 'Tillagd' : 'Försök igen';
    setTimeout(() => {
      if (!button.isConnected) return;
      button.textContent = label;
      button.disabled = false;
    }, 2000);
  }
});

document.addEventListener(StandardEvents.cartLinesUpdate, (event) => {
  const promise = /** @type {any} */ (event).promise;
  if (!promise) return;
  promise
    .then(() => fetch(cartJsonUrl(), { headers: { Accept: 'application/json' } }))
    .then((r) => r.json())
    .then((cart) => setCount(cart.item_count))
    .catch(() => {});
});